/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import { G, Path, Svg } from '@react-pdf/renderer';
import { jsx } from 'theme-ui';
const sizes = {
  xxsmall: 10,
  xsmall: 15,
  small: 20,
  smallMedium: 30,
  medium: 40,
  mediumLarge: 50,
  large: 60,
  xlarge: 120,
};

/**
 * A star icon.
 * @param {object} props
 * @param {string} [props.color]
 * @param {string} [props.className]
 * @param {object} [props.style]
 * @param {'filled' | 'hollow'} [props.variant]
 * @param {import('@bottlebooks/gatsby-design-system/src/components/icons/sizes').IconSize} [props.size] The icon size.
 */
export default function BookmarkIcon({
  size = 'small',
  variant = 'filled',
  color = 'black',
  style,
  ...rest
}) {
  if (variant === 'hollow') {
    return (
      <Svg
        xmlns="http://www.w3.org/2000/svg"
        style={[
          {
            width: sizes[size],
            height: sizes[size],
            verticalAlign: 'sub',
          },
          style,
        ]}
        fill="none"
        viewBox="0 0 50 50"
        {...rest}
      >
        <G stroke="#eee" transform="matrix(-1 0 0 1 49 1)">
          <circle cx="24" cy="24" r="24" fill="white"></circle>
          <Path
            stroke={color}
            fill="#FFF"
            d="M33.547 9.6v24.467c.511 5.777-2.671 5.777-9.547 0-6.876 5.777-10.058 5.777-9.547 0V9.6H14.4h19.2"
          ></Path>
        </G>
      </Svg>
    );
  }
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      style={[
        {
          width: sizes[size],
          height: sizes[size],
          verticalAlign: 'sub',
        },
        style,
      ]}
      viewBox="0 0 50 50"
      fill="none"
      {...rest}
    >
      <G stroke={color} transform="matrix(-1 0 0 1 49 1)">
        <circle cx="24" cy="24" r="24" fill={color}></circle>
        <Path
          stroke={color}
          fill={color}
          d="M33.547 9.6v24.467c.511 5.777-2.671 5.777-9.547 0-6.876 5.777-10.058 5.777-9.547 0V9.6H14.4h19.2"
        ></Path>
      </G>
    </Svg>
  );
}
